<template>
  <div class="row m-3 striped-row">
    <template v-if="toggled">
      <div :title="stripTag(nameTagKey)" class="col-lg-4 col-md-6 col-xs-6 mt-10">
        <p class="ml-45 mt-5 answer-font-size text-overflow" v-html="stripTag(nameTagKey)"></p>
      </div>
      <div class="col-lg-8 col-md-6 col-xs-6 p-10 flex flex-row-wrap">
        <template v-if="answerToSkillArr.length">
          <template v-for="({ FK_skillKey, points }, j) in answerToSkillArr">
            <div :key="`${FK_skillKey}-${j}`" class="pr-10">
              <div
                :class="{ positive: isPositive(points), negative: !isPositive(points) }"
                class="p-5 mb-5 skill-font-size"
              >
                <span :title="getSkillName(FK_skillKey)" class="skill-font-weight"
                  >{{ displayName('', 15, FK_skillKey) }}:</span
                >
                <span>{{ isPositive(points) ? ` +${points}` : `${points}` }}</span>
              </div>
            </div>
          </template>
        </template>
        <template v-else>
          <p class="skill-font-size ml-5">No Skills Assigned</p>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    props: {
      nameTagKey: {
        type: String,
        required: true,
      },
      answerKey: {
        type: String,
        required: true,
      },
      answerToSkill: {
        type: Object,
        required: true,
      },
      toggled: {
        type: Boolean,
        defaut: false,
      },
    },

    methods: {
      getSkillName(skillKey) {
        if (skillKey) {
          return this.skills[skillKey].name;
        }
      },
      displayName(name, num, skillKey) {
        if (skillKey) name = this.getSkillName(skillKey);

        return name.length > num ? name.substring(0, num + 1) + '...' : name;
      },
      isPositive(points) {
        return points > 0 ? true : false;
      },
      stripTag(value) {
        return value.replace(/<\/?[^>]+>/gi, ' '); // title attribute cannot use v-html
      },
    },
    computed: {
      ...mapState('editMode/skills', ['skills']),
      answerToSkillArr() {
        return Object.values(this.answerToSkill);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .striped-row:nth-of-type(2n + 1) {
    background: #f7f7f7;
  }
  .positive {
    background-color: #d4e5da;
  }
  .negative {
    background-color: #f5e8e8;
  }
  .skill-font-weight {
    font-weight: bold;
  }
  .skill-font-size {
    font-size: 0.75em;
  }
  .answer-font-size {
    font-size: 0.875em;
  }
  .text-overflow {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 88%;
  }
</style>
